import { useQueryClient } from "@tanstack/react-query";
import { addSubproperty } from "../api";
import { AddSubPropertyDTO } from "../dtos";
import { Property } from "../types";
import { useDomainMutation } from "@/modules/common/hooks/domain-mutation.hook";

export function useAddSubproperty() {
  const queryClient = useQueryClient();

  const mutationAddSubproperty = useDomainMutation<
    Property,
    { response?: { data?: { message?: string } } },
    { uid: string; data: AddSubPropertyDTO }
  >({
    mutationFn: async ({ uid, data }) => {
      const response = await addSubproperty(uid, {
        ...data,
        property: {
          ...data.property,
          propertyPrice:
            Object.keys(data.property.propertyPrice ?? {}).length > 0
              ? data.property.propertyPrice
              : undefined,
        },
      });
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["sub-properties"] });
      queryClient.invalidateQueries({ queryKey: ["track"] });
    },
  });

  return mutationAddSubproperty;
}
